// extracted by mini-css-extract-plugin
export default {"title":"PlantListPage_title__BXZIx"};